import { Box, Skeleton, useTheme, VStack } from "native-base";
import React from "react";

const RecipeCardSkeleton = (): JSX.Element => {
  const theme = useTheme();

  return (
    <Box flex={1}>
      <Box
        bg="primary.10"
        borderRadius={theme.borderRadii.card.default}
        mx={1}
        mb={3}
        shadow="10"
        overflow="hidden"
        flex={1}
      >
        {/* Image Skeleton */}
        <Box p={2}>
          <Box width="100%" style={{ aspectRatio: 1 }} borderRadius={theme.borderRadii.card.default} overflow="hidden">
            <Skeleton height="100%" width="100%" />
          </Box>
        </Box>

        {/* Content Skeleton */}
        <VStack px={2} pb={2} pt={0} space={1}>
          {/* Recipe Name Skeleton - 2 lines */}
          <Skeleton.Text lines={2} lineHeight="sm" />

          {/* Preparation Time Skeleton */}
          <Skeleton height={3} width="60px" />
        </VStack>
      </Box>
    </Box>
  );
};

export default RecipeCardSkeleton;
